import React, { useCallback, useMemo, useState } from 'react'
import { submitReportProgress } from '@/enums/submitReportProgress'
import Resx from '@/components/Resx'
import context from '@/context'
import { SimpleCard } from '@/report-app/pages/reporting/submissions/submit/simpleCard'
import { Button } from '@/components/button'
import { decomposeError } from '@/utils/fetch'
import { useLocalization } from '@/hooks/localization'

function CreateTicketCard ({ reportInstanceGroupId, submitProgress, onSubmitProgressChange }) {
  const [failMessage, setFailMessage] = useState('')
  const { localize } = useLocalization()

  const cardColor = useMemo(() => failMessage ? 'danger' : '', [failMessage])
  const icon = useMemo(() => failMessage ? 'bx-error' : '', [failMessage])

  const createTicket = useCallback(() =>
    context.api.reportSubmissionGroupService.createTicket(reportInstanceGroupId)
      .then(() => onSubmitProgressChange(submitReportProgress.enum.TicketCreated))
      .catch((e) => {
        const { statusCode, errorMessage } = decomposeError(e)
        if (statusCode === 400) {
          setFailMessage(errorMessage)
        } else {
          setFailMessage(localize('Reporting.UnknownSubmitError'))
        }
      })
  , [localize, onSubmitProgressChange, reportInstanceGroupId])

  return <SimpleCard dataCy='createTicketCard'
    cardColor={cardColor}
    icon={icon}
    submitProgress={submitProgress}
    beforeStartText='Reporting.TicketCreation'
    finishedMessage='Reporting.TicketCreatedText'
    headerText='Reporting.TicketCreation'
    activateSubmitProgress={submitReportProgress.enum.Signed}>
    {failMessage ? <p>{failMessage}</p> : null}
    <Button icon='bx-send' color='primary'
      confirmTitle='Reporting.TicketCreation'
      confirmText='Reporting.TicketCreationText'
      onClick={createTicket}>
      <Resx name='Reporting.CreateTicket' />
    </Button>
  </SimpleCard>
}

export { CreateTicketCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/createTicketCard.js